import {FloatingContainer} from "../AppStyle";
import styled from "styled-components";

export const AddressesFloatingContainer = styled.div`
    ${FloatingContainer};
    position: fixed;
    top: 58px;
    left: 11px;
    z-index: 1;
    background-color: rgb(255, 255, 255);
    text-align: center;
    line-height: 30px;
    vertical-align: middle;
    padding-top: 6px;
    padding-bottom: 6px;
    padding-left: 6px;
    padding-right: 6px;
`;

export const AddressesFloatingContainerTopRow = styled.div`
    display: flex;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
`;

export const AddressesFloatingContainerBottomRow = styled.div`
    display: flex;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
`;


// WEBPACK FOOTER //
// ./src/Components/FloatingAddressContainer/FloatingAddressContainerStyle.js